import { defineTokens } from "@chakra-ui/react";

export const sizesToken = defineTokens.sizes({
    "8xl": "73rem", // 1168px
});
